class LocalStorage {
  private static store = window.localStorage

  public static clear() {
    return this.store.clear()
  }

  public static getItem<T = unknown>(key: string): T | null {
    const value = this.store.getItem(key)
    if (value === null) {
      return null
    }

    try {
      return JSON.parse(value)
    } catch (error) {
      return value as T
    }
  }

  public static setItem(key: string, value: string | any) {
    try {
      this.store.setItem(key, JSON.stringify(value))
    } catch (error) {
      this.store.setItem(key, value)
    }
  }

  public static getItemExpire<T = unknown>(key: string): T | null {
    const value = this.store.getItem(key)
    if (value === null) {
      return null
    }

    try {
      const data = JSON.parse(value)
      if (!data.expireAt) {
        return JSON.parse(value)
      }

      if (data.expireAt < Date.now()) {
        this.removeItem(key)
        return null
      }
      return data.data
    } catch (error) {
      return null
    }
  }

  public static setItemExpire(key: string, value: string | any, expireTime: number) {
    const data = {
      data: value,
      expireAt: Date.now() + expireTime * 1000
    }

    this.store.setItem(key, JSON.stringify(data))
  }

  public static removeItem(key: string) {
    return this.store.removeItem(key)
  }

  public static key(index: number): string | null {
    return this.store.key(index)
  }
}

export default LocalStorage
